import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarginRightIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M3.33398 6.5L3.33398 13.5C3.33398 14.9001 3.33398 15.6002 3.53078 16.135C3.70388 16.6054 3.9801 16.9878 4.31983 17.2275C4.70606 17.5 5.21167 17.5 6.22287 17.5L11.2784 17.5C12.2896 17.5 12.7952 17.5 13.1815 17.2275C13.5212 16.9878 13.7974 16.6054 13.9705 16.135C14.1673 15.6002 14.1673 14.9001 14.1673 13.5L14.1673 10L14.1673 6.5C14.1673 5.09987 14.1673 4.3998 13.9705 3.86502C13.7974 3.39462 13.5212 3.01217 13.1815 2.77248C12.7952 2.5 12.2896 2.5 11.2784 2.5L6.22287 2.5C5.21167 2.5 4.70606 2.5 4.31983 2.77248C3.9801 3.01217 3.70388 3.39462 3.53078 3.86502C3.33398 4.3998 3.33398 5.09987 3.33398 6.5Z"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 5.41537L17.5 9.9987L17.5 14.582"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
